import React from 'react';

// Renders admin-editable text: a blank line starts a new paragraph and a
// line starting with "## " is a heading. Plain text only, never HTML.
const TextBlocks = ({ text, paragraphClassName = 'text-gray-700 mb-4', headingClassName = 'text-2xl font-semibold mt-6 mb-3' }) => {
  const blocks = String(text || '')
    .split(/\n\s*\n/)
    .map((block) => block.trim())
    .filter(Boolean);

  return blocks.map((block, index) =>
    block.startsWith('## ') ? (
      <h2 key={index} className={headingClassName}>{block.slice(3)}</h2>
    ) : (
      <p key={index} className={paragraphClassName}>{block}</p>
    )
  );
};

export default TextBlocks;
